import { combineReducers } from 'redux';

import { createResourcesReducer, createRootLinkReducer, mlRel } from 'medialoopster/rest';

import { ANNOTATION_OPTIONS_LOADED, AnnotationOptionsLoaded, AnnotationRootState } from './types';

export const annotationPermissionReducer = (
  state = false,
  action: AnnotationOptionsLoaded,
): boolean => {
  switch (action.type) {
    case ANNOTATION_OPTIONS_LOADED:
      return 'POST' in action.payload.actions;
    default:
      return state;
  }
};
export default combineReducers<AnnotationRootState>({
  annotations: createResourcesReducer('annotation'),
  annotationEndpointLink: createRootLinkReducer(mlRel('annotations')),
  publishAnnotationsLink: createRootLinkReducer(mlRel('annotations_publish')),
  unpublishAnnotationsLink: createRootLinkReducer(mlRel('annotations_unpublish')),
  deleteAnnotationsLink: createRootLinkReducer(mlRel('annotations_bulk_delete')),
  hasAnnotationPermission: annotationPermissionReducer,
});
